// Native & external imports
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CmpSharedModule } from 'icamppro-shared-components';
// Components
import { PasswordResetComponent } from './password-reset.component';

@NgModule({
  declarations: [
    PasswordResetComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CmpSharedModule
  ],
  exports: [
    PasswordResetComponent
  ]
})
export class PasswordResetModule { }
